import { render } from "./ConsultancyServiceSection.vue?vue&type=template&id=a3f106fa&scoped=true"
import script from "./ConsultancyServiceSection.vue?vue&type=script&lang=js"
export * from "./ConsultancyServiceSection.vue?vue&type=script&lang=js"

import "./ConsultancyServiceSection.vue?vue&type=style&index=0&id=a3f106fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f106fa"],['__file',"ConsultancyServiceSection.vue"]])

export default __exports__